import PropTypes from "prop-types";

/**
 * 只給開發者看的提示（2026-09-09 裁示：契約缺欄、swagger 沒端點、「先佔位」這類話
 * 不該出現在任何部署出去的站台，不論 testenv 或正式站）。
 *
 * 判斷用 `NODE_ENV`：`npm start` 是 development 才渲染；`npm run build` 出來的東西一律
 * production，不管 REACT_APP_* 怎麼設都不會出現 —— 所以不用另外開一個旗標讓人忘了關。
 * 測試環境（test）也不渲染，頁面測試因此能直接斷言「使用者看不到內部字眼」。
 *
 * 用法：包住那段 Alert／小字即可；要留給使用者看的話，請改寫成不含內部詞彙的文案，別包這個。
 */
export const isDevNoteVisible = () => process.env.NODE_ENV === "development";

const DevNote = ({ children }) => (isDevNoteVisible() ? children : null);
DevNote.propTypes = { children: PropTypes.node };

export default DevNote;
